<div class="swiper-gallery">
  <div class="gallery-top">
    <swiper #swiper [config]="config" (swiper)="onSwiperInit()" (slideChange)=" thumbnails&&onSlideChange($event)">
      <ng-template *ngFor="let item of items; let i = index" swiperSlide>
        <img [src]="item?.links?.full||item.img||item" />
        <div class="slide-caption">
          <h1 *ngIf="item.header">{{item.header}}</h1>
          <h2 *ngIf="item.subheader">{{item.subheader}}</h2>
          <a [href]="item.link" *ngIf="item.text"><h4>{{item.text}}</h4></a>
        </div>
      </ng-template>
    </swiper>
  </div>

    <div class="gallery-thumbs" *ngIf="!isSingle&&thumbnails">
      <swiper #thumb [config]="thumbConfig" (swiper)="onSwiperInit()" (slideChange)="onSlideChange($event)">
        <ng-template *ngFor="let item of items; let i = index" swiperSlide>
          <img [src]="item?.links?.thumb" />
        </ng-template>
    </swiper>
  </div>

  
  <button class="close" *ngIf="closing" (click)="close()">
    <ico></ico>
  </button>
</div>
